import React from "react";
import { observer } from "mobx-react";
import { Row, Col } from "antd";
import { FormField, IButton } from "../../../../ui-kit";
import defectCardsStore from "../../../../store/defectCards";
import { useHandleForm } from "../../../../hooks/useHandleForm";
import { schema } from "./validator";
import styles from "../defectReject/DefectReject.module.scss";

interface IDefectRemove {
  defectId: string;
  targetKey: string;
  onClose: (e: React.MouseEvent<Element, MouseEvent>) => void;
}

const DefectRemove: React.FC<IDefectRemove> = observer(
  ({ defectId, onClose, targetKey }) => {
    const { defectRemoveFormIsSending } = defectCardsStore;
    const initialValues = {
      message: "",
    };
    const initialFocus = {};
    const { register, handleSubmit, watchAllField, errors } = useHandleForm(
      schema,
      initialValues,
      initialFocus,
    );

    const onSubmit = (values) => {
      defectCardsStore.sendDefectRemove(defectId, values, targetKey);
    };

    return (
      <form onSubmit={handleSubmit(onSubmit)} className={styles.defectReject}>
        <Row>
          <Col span={24}>
            <FormField
              className={styles.defectRejectField}
              register={register}
              label="Укажите причину удаления"
              name="message"
              type="textarea"
              currentValue={watchAllField.message}
              error={errors?.message?.message}
              isRequired
            />
          </Col>
        </Row>
        <Row className={styles.defectRejectButtonWrapper}>
          <Col span={12} className={styles.defectRejectButton}>
            <IButton disabled={defectRemoveFormIsSending.value}>
              Удалить
            </IButton>
          </Col>
          <Col span={12} className={styles.defectRejectButton}>
            <IButton onClick={onClose} variant="outlined" type="button">
              Отмена
            </IButton>
          </Col>
        </Row>
      </form>
    );
  },
);

export default DefectRemove;
